import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/** Data passed into the CPF acknowledgment modal. */
export interface KycCpfAckData {
  /** Optional document label for context (e.g. "RG"). */
  documentTitle?: string;
}

/** Result returned when the modal closes. */
export interface KycCpfAckResult {
  /** true = both attestations accepted, proceed with submission. */
  acknowledged: boolean;
}

/**
 * 🇧🇷 CPF acknowledgment modal. Shown when the system could NOT read a valid CPF
 * on a document family that legitimately may not carry one (RG / Carteira de
 * Pescador / Certidão / Outro). Instead of a hard reject, the user attests that
 * the CPF is present + matches, and acknowledges the cancellation risk, before
 * the flow proceeds. Pure UI — the parent records the attestation and submits.
 */
@Component({
  selector: 'app-kyc-cpf-ack-modal',
  templateUrl: './kyc-cpf-ack-modal.component.html',
  styleUrls: ['./kyc-cpf-ack-modal.component.scss'],
})
export class KycCpfAckModalComponent {
  /** First required attestation: CPF is present and matches the provided one. */
  presentAttested = false;
  /** Second required attestation: understands the cancellation risk. */
  riskAttested = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KycCpfAckData = {},
    private dialogRef: MatDialogRef<KycCpfAckModalComponent, KycCpfAckResult>
  ) {
    this.dialogRef.disableClose = true;
  }

  /** Confirm is only enabled once BOTH checkboxes are ticked. */
  get canConfirm(): boolean {
    return this.presentAttested && this.riskAttested;
  }

  onConfirm(): void {
    if (!this.canConfirm) return;
    this.dialogRef.close({ acknowledged: true });
  }

  onCancel(): void {
    this.dialogRef.close({ acknowledged: false });
  }
}
